// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__m6iUb","content":"DefaultLayout_content__twAs5"};